import { useMemo } from 'react'

import { TeamRole } from '@/consts/team'
import { TeamFSContext } from '@/pages/data-mgr/core/context'
import { type MoveDialogProps, useMoveCore } from '@/pages/data-mgr/core/hooks/useMove'

export type { MoveDialogProps }

export function useTeamMove(domain: number, userRole: TeamRole, teamId: number) {
  const context = useMemo(() => new TeamFSContext(userRole, teamId), [userRole, teamId])
  return useMoveCore(context, domain)
}
